import {observer} from 'mobx-react';
import React from 'react';
import ButtonHoc from '../ButtonHoc/ButtonHoc';
import styles from './ButtonNext.module.scss';

interface ButtonNextProps {
    onClick?: () => void;
    disabled?: boolean;
    ariaLabel?: string | 'unlabeled';
    disabledWithoutColorChange?: boolean;
    debounceTime?: number;
    textBtn?: string | React.ReactElement;
    className?: string;
    // show children instead of text if present
    children?: React.ReactNode;
}

const ButtonNext: React.FC<ButtonNextProps> = ({
    onClick,
    disabled,
    disabledWithoutColorChange,
    debounceTime,
    ariaLabel,
    textBtn,
    className,
    children,
}) => {
    function getContents() {
        if (children) {
            return children;
        } else {
            return <>{textBtn ? textBtn : 'Next'}</>;
        }
    }

    return (
        <ButtonHoc
            ariaLabel={ariaLabel}
            className={[styles.ButtonNext, disabled && styles.disabled, textBtn && styles.textBtn, className].join(' ')}
            disabled={disabled || disabledWithoutColorChange}
            debounce={debounceTime}
            onClick={onClick}
        >
            {getContents()}
        </ButtonHoc>
    );
};

export default observer(ButtonNext);
